<template>
  <div class="page-container">
    <PageHeader title="菜单权限">
      <template #actions>
        <div class="auth-header-actions">
          <el-input
            v-model="formDatas.authName"
            placeholder="搜索菜单名称"
            clearable
            size="small"
            class="search-input"
            @keyup.enter.native="partserch"
          />
          <el-button type="primary" size="small" icon="el-icon-searchplus" class="auth-search-button" @click="partserch">搜索</el-button>
          <el-button size="small" icon="el-icon-refresh" class="auth-reset-button" @click="resetSearch">重置</el-button>
          <el-button type="primary" size="small" icon="el-icon-circle-plusplus" class="auth-add-button" @click="BoxOpen">
            新增{{ level == 0 ? '目录' : level == 1 ? '菜单' : '按钮' }}
          </el-button>
        </div>
      </template>
    </PageHeader>

    <TablePanel title="权限列表">
      <template #extra>
        <span class="level-hint">层级：{{ level == 0 ? '目录' : level == 1 ? '菜单' : '按钮' }}</span>
      </template>
      <el-tabs
        v-model="editableTabsValue"
        type="card"
        :closable="level != 0"
        @edit="handleTabsEdit"
        @tab-click="tabsClick"
      >
        <el-tab-pane
          v-for="item in editableTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
        />
      </el-tabs>
      <aj-table
        v-loading="loading"
        :data="tableData"
        :columns="columns"
        row-id-key="authId"
        :use-internal-pagination="true"
        :total="totalCount"
        :current-page.sync="formDatas.currentPage"
        :page-size.sync="formDatas.pageSize"
        :page-sizes="[10, 20, 40, 80, 160]"
        @page-change="handlePageChange"
        @operate-btn-click="handleOperateBtnClick"
      >
        <template #cell-authIcon="{ row }">
          <div class="auth-icon-cell" :title="row.authIcon || '未配置图标'">
            <i v-if="row.authIcon" :class="row.authIcon"></i>
            <span class="auth-icon-cell__name">{{ row.authIcon || '未配置' }}</span>
          </div>
        </template>
      </aj-table>
      <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
    </TablePanel>

    <!-- 右侧抽屉 -->
    <el-drawer
      :title="edit ? '编辑功能' : '新增功能'"
      :visible.sync="drawerVisible"
      direction="rtl"
      size="500px"
      :wrapper-closable="false"
      custom-class="auth-drawer"
      append-to-body
      modal-append-to-body
      @close="handleDrawerClose"
    >
      <div class="drawer-form-body">
        <el-form ref="formRef" :model="form" label-position="top" :rules="rules">
          <el-form-item label="类型" prop="authType">
            <el-radio-group v-model="form.authType" :disabled="edit">
              <el-radio :label="0">目录</el-radio>
              <el-radio :label="1">菜单</el-radio>
              <el-radio :label="2">按钮</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="父级权限id" prop="authParentId">
            <el-input v-model="form.authParentId" disabled />
          </el-form-item>
          <el-form-item label="菜单权限名称" prop="authName">
            <el-input v-model="form.authName" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="地址" prop="authUrl">
            <el-input v-model="form.authUrl" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="接口参数" prop="authParams">
            <el-input v-model="form.authParams" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="描述" prop="authRemark">
            <el-input v-model="form.authRemark" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="排序" prop="authOrder">
            <el-input v-model="form.authOrder" type="number" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="图标" prop="authIcon">
            <el-input v-model="form.authIcon" placeholder="请选择或输入图标类名" clearable>
              <template #prepend>
                <i v-if="form.authIcon" :class="form.authIcon"></i>
                <span v-else>图标</span>
              </template>
            </el-input>
            <div class="auth-icon-picker">
              <button
                v-for="icon in iconOptions"
                :key="icon.value"
                type="button"
                class="auth-icon-picker__item"
                :class="{ 'is-active': form.authIcon === icon.value }"
                @click="selectIcon(icon.value)"
              >
                <i :class="icon.value"></i>
                <span>{{ icon.label }}</span>
              </button>
            </div>
          </el-form-item>
          <el-form-item label="操作类型(0查询 1新增 2编辑 3删除)" prop="authOperationType">
            <el-input v-model="form.authOperationType" type="number" placeholder="请输入" />
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="SureBtn">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getRtAuthList, addRtAuth, updateRtAuth, deleteRtAuth } from '@/api/system'
import AjTable from '@/components/ajTable/ajTable.vue'
import PageHeader from '@/components/PageHeader.vue'
import TablePanel from '@/components/TablePanel.vue'

const AUTH_ICON_OPTIONS = [
  { label: '用户中心', value: 'el-icon-s-customplus' },
  { label: '用户', value: 'el-icon-userplus' },
  { label: '个人资料', value: 'el-icon-user-solidplus' },
  { label: '角色', value: 'el-icon-s-checkplus' },
  { label: '组织', value: 'el-icon-office-buildingplus' },
  { label: '团队', value: 'el-icon-serviceplus' },
  { label: '我的报告', value: 'el-icon-suitcaseplus' },
  { label: '商务', value: 'el-icon-briefcaseplus' },
  { label: '报告管理', value: 'el-icon-folderplus' },
  { label: '打开目录', value: 'el-icon-folder-openedplus' },
  { label: '新增目录', value: 'el-icon-folder-addplus' },
  { label: '已归档', value: 'el-icon-folder-checkedplus' },
  { label: '文件库', value: 'el-icon-filesplus' },
  { label: '系统管理', value: 'el-icon-s-toolsplus' },
  { label: '设置', value: 'el-icon-settingplus' },
  { label: '菜单管理', value: 'el-icon-s-managementplus' },
  { label: '操作权限', value: 'el-icon-s-operationplus' },
  { label: '菜单网格', value: 'el-icon-s-gridplus' },
  { label: '展开', value: 'el-icon-s-unfoldplus' },
  { label: '报表', value: 'el-icon-documentplus' },
  { label: '审批', value: 'el-icon-document-checkedplus' },
  { label: '清单', value: 'el-icon-document-copyplus' },
  { label: '申请', value: 'el-icon-s-claimplus' },
  { label: '打印', value: 'el-icon-printerplus' },
  { label: '协作', value: 'el-icon-s-cooperationplus' },
  { label: '数据分析', value: 'el-icon-data-analysisplus' },
  { label: '数据看板', value: 'el-icon-data-boardplus' },
  { label: '趋势', value: 'el-icon-data-lineplus' },
  { label: '营销', value: 'el-icon-s-marketingplus' },
  { label: '公告', value: 'el-icon-newsplus' },
  { label: '消息', value: 'el-icon-bellplus' },
  { label: '会话', value: 'el-icon-messageplus' },
  { label: '锁定', value: 'el-icon-lockplus' },
  { label: '退出', value: 'el-icon-switch-buttonplus' },
  { label: '帮助', value: 'el-icon-helpplus' },
  { label: '说明', value: 'el-icon-infoplus' },
  { label: '搜索', value: 'el-icon-searchplus' },
  { label: '查看', value: 'el-icon-viewplus' },
  { label: '定位', value: 'el-icon-c-scale-to-originalplus' },
  { label: '新增', value: 'el-icon-circle-plusplus' },
  { label: '删除', value: 'el-icon-deleteplus' },
  { label: '通过', value: 'el-icon-checkplus' },
  { label: '成功', value: 'el-icon-successplus' },
  { label: '预警', value: 'el-icon-warningplus' },
  { label: '异常', value: 'el-icon-errorplus' },
  { label: '机会', value: 'el-icon-s-opportunityplus' },
  { label: '速度', value: 'el-icon-odometerplus' },
  { label: '时间', value: 'el-icon-timeplus' },
  { label: '链接', value: 'el-icon-linkplus' },
  { label: 'CPU', value: 'el-icon-cpuplus' },
  { label: '导出', value: 'el-icon-downloadplus' },
  { label: '上传', value: 'el-icon-uploadplus' },
  { label: '图片', value: 'el-icon-pictureplus' },
  { label: '收藏', value: 'el-icon-star-onplus' }
]

const BASE_COLUMNS = [
  { type: 'index', prop: 'index', label: '序号', width: 50, align: 'center', fixed: 'left' },
  { prop: 'authName', label: '菜单名称', minWidth: 180, fixed: 'left' },
  { prop: 'authUrl', label: '菜单地址', minWidth: 250 },
  { prop: 'authRemark', label: '描述', minWidth: 150 },
  { prop: 'authParams', label: '接口参数', minWidth: 250 },
  { prop: 'authOrder', label: '排序', width: 100 },
  { prop: 'authIcon', label: '图标', width: 190 },
  { prop: 'authOperationType', label: '操作类型', width: 160, align: 'center' },
  { prop: 'createtime', label: '创建时间', width: 160 }
]

export default {
  name: 'SystemAuthPage',
  components: { AjTable, PageHeader, TablePanel },
  data () {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      totalCount: 0,
      drawerVisible: false,
      edit: false,
      form: {
        authParentId: 0,
        authName: '',
        authUrl: '',
        authParams: '',
        authRemark: '',
        authOrder: 0,
        authIcon: '',
        authOperationType: 0
      },
      rules: {},
      // Tab 逐级增加
      editableTabsValue: '0',
      editableTabs: [{ title: '目录', name: '0', authParentId: 0 }],
      level: 0,
      authParentId: 0,
      // 新版菜单图标候选项，新增/编辑时可直接点选并保存类名。
      iconOptions: AUTH_ICON_OPTIONS,
      // 搜索与分页
      formDatas: {
        authName: '',
        authType: 0,
        authParentId: 0,
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    columns () {
      return [
        ...BASE_COLUMNS,
        {
          type: 'operation',
          prop: 'operation',
          label: '操作',
          width: 260,
          fixed: 'right',
          buttons: [
            {
              text: '查看菜单',
              type: 'text',
              isShow: (row) => row.authType === 0 && (!row.authRemark || row.authRemark.indexOf('#') === -1)
            },
            {
              text: '查看按钮',
              type: 'text',
              isShow: (row) => row.authType === 1 || (row.authRemark && row.authRemark.indexOf('#') > -1)
            },
            {
              text: '删除',
              type: 'text',
              class: 'text-danger'
            },
            {
              text: '编辑',
              type: 'text'
            }
          ]
        }
      ]
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const params = {
          authName: this.formDatas.authName,
          authType: this.level,
          authParentId: this.authParentId,
          currentPage: this.formDatas.currentPage,
          pageSize: this.formDatas.pageSize
        }
        const res = await getRtAuthList(params)
        this.tableData = Array.isArray(res.data) ? res.data : []
        this.totalCount = res.total || this.tableData.length
      } catch (error) {
        this.tableData = []
        this.totalCount = 0
      } finally {
        this.loading = false
      }
    },
    partserch () {
      this.formDatas.authType = this.level
      this.formDatas.authParentId = this.authParentId
      this.formDatas.currentPage = 1
      this.fetchList()
    },
    resetSearch () {
      this.formDatas.authName = ''
      this.partserch()
    },
    selectIcon (icon) {
      this.form.authIcon = icon
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.formDatas.currentPage = currentPage
      this.formDatas.pageSize = pageSize
      this.fetchList()
    },
    handleOperateBtnClick ({ btn, row }) {
      if (btn.text === '查看菜单' || btn.text === '查看按钮') {
        this.handleLevel(row)
      } else if (btn.text === '编辑') {
        this.handleEdit(row)
      } else if (btn.text === '删除') {
        this.handleDelete(row)
      }
    },
    formatOperationType (row) {
      if (row.authOperationType === 0) return '查询'
      if (row.authType === 1) return '新增'
      if (row.authType === 2) return '编辑'
      return '删除'
    },
    // ===== Tabs 逐级增加 =====
    tabsClick (e) {
      this.editableTabsValue = e.name
      this.level = Number(e.name.split('_')[0])
      const tabItem = this.editableTabs.find(t => t.name === e.name)
      this.authParentId = tabItem ? (tabItem.authParentId || 0) : 0
      this.partserch()
    },
    handleTabsEdit (targetName, action) {
      if (action === 'remove') {
        const tabs = this.editableTabs
        let activeName = this.editableTabsValue
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              const nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        }
        this.editableTabsValue = activeName
        const tabarr = this.editableTabs = tabs.filter(tab => tab.name !== targetName)
        const lastTab = tabarr[tabarr.length - 1]
        this.level = Number(lastTab.name.split('_')[0])
        this.authParentId = lastTab.authParentId || 0
        this.partserch()
      }
    },
    handleLevel (row) {
      let nextLevel
      if (row.authRemark && row.authRemark.indexOf('#') > -1) {
        nextLevel = 2
      } else {
        nextLevel = row.authType + 1
      }
      this.level = nextLevel
      this.authParentId = row.authId
      const tabName = `${nextLevel}_${row.authId}`
      const tabTitle = nextLevel === 1 ? '菜单' : '按钮'
      const newTab = { title: tabTitle, name: tabName, authParentId: row.authId }
      const existingIndex = this.editableTabs.findIndex(t => t.name === tabName)
      if (existingIndex !== -1) {
        this.editableTabs.splice(existingIndex, 1, newTab)
      } else {
        this.editableTabs.push(newTab)
      }
      this.editableTabsValue = tabName
      this.partserch()
    },
    // ===== 新增/编辑抽屉 =====
    BoxOpen () {
      this.edit = false
      this.form = {
        authType: this.level,
        authParentId: this.authParentId,
        authName: '',
        authUrl: '',
        authParams: '',
        authRemark: '',
        authOrder: 0,
        authIcon: '',
        authOperationType: 0
      }
      this.drawerVisible = true
    },
    handleEdit (row) {
      this.edit = true
      this.$nextTick(() => {
        this.form = JSON.parse(JSON.stringify(row))
      })
      this.drawerVisible = true
    },
    handleDrawerClose () {
      if (this.$refs.formRef) this.$refs.formRef.resetFields()
    },
    SureBtn () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const payload = { ...this.form }
        payload.authOrder = Number(payload.authOrder) || 0
        payload.authOperationType = Number(payload.authOperationType) || 0
        if (!this.edit) {
          addRtAuth(payload)
            .then(res => {
              if (res.data) {
                this.$message.success('新增成功!')
                this.drawerVisible = false
                this.fetchList()
              }
            })
            .finally(() => { this.submitLoading = false })
        } else {
          updateRtAuth(payload)
            .then(res => {
              if (res.data) {
                this.$message.success('编辑成功!')
                this.drawerVisible = false
                this.fetchList()
              }
            })
            .finally(() => { this.submitLoading = false })
        }
      })
    },
    handleDelete (row) {
      this.$confirm('是否确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteRtAuth({ authId: row.authId })
            .then(res => {
              if (res.data) {
                this.$message.success('删除成功!')
                this.fetchList()
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.auth-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;

  .search-input {
    width: 220px;
  }
}

.auth-header-actions ::v-deep .auth-search-button.el-button--primary {
  color: #fff !important;
  border-color: transparent !important;
  background:
    radial-gradient(circle at 22% 20%, rgba(255, 255, 255, 0.34) 0 14%, transparent 28%),
    linear-gradient(135deg, #0ea5e9 0%, #2563eb 58%, #4f46e5 100%) !important;
  box-shadow: 0 10px 18px rgba(37, 99, 235, 0.24) !important;
}

.auth-header-actions ::v-deep .auth-search-button [class$="plus"] {
  width: 19px;
  height: 19px;
  margin-right: 5px;
}

.auth-header-actions ::v-deep .auth-add-button.el-button--primary {
  color: #fff !important;
  border-color: transparent !important;
  background:
    radial-gradient(circle at 24% 20%, rgba(255, 255, 255, 0.34) 0 14%, transparent 28%),
    linear-gradient(135deg, #10b981 0%, #16a34a 54%, #2563eb 100%) !important;
  box-shadow: 0 10px 18px rgba(16, 185, 129, 0.24) !important;
}

.auth-header-actions ::v-deep .auth-reset-button.el-button {
  color: #475569 !important;
  border-color: rgba(203, 213, 225, 0.9) !important;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%) !important;
  box-shadow: 0 7px 14px rgba(100, 116, 139, 0.1) !important;
}

.level-hint {
  font-size: 12px;
  color: #64748b;
  padding: 4px 10px;
  background: #f8fafc;
  border-radius: 20px;
}

.auth-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.action-placeholder {
  display: inline-block;
  width: 0;
}

.text-danger { color: #ef4444 !important; }

::v-deep .aj-table-operation-link {
  margin: 0 4px;
  font-size: 12px;
  font-weight: 500;

  &.text-danger {
    color: #ef4444 !important;

    &:hover {
      color: #dc2626 !important;
    }
  }

  &:not(.text-danger):hover {
    color: #4f7cff !important;
  }
}

.auth-icon-cell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 100%;
}

.auth-icon-cell i[class$="plus"] {
  width: 24px;
  height: 24px;
  margin-right: 0;
}

.auth-icon-cell__name {
  max-width: 92px;
  color: #475569;
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
}

.auth-icon-picker {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px 10px;
  max-height: 420px;
  margin-top: 12px;
  padding: 14px 4px 8px;
  border: 0;
  border-radius: 0;
  background: transparent;
  overflow-y: auto;
}

.auth-icon-picker__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 78px;
  padding: 8px 4px;
  border: 0;
  border-radius: 14px;
  color: #475569;
  background: transparent;
  cursor: pointer;
  transition: all 0.16s ease;
}

.auth-icon-picker__item i[class$="plus"] {
  width: 34px;
  height: 34px;
  margin: 0 0 7px;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  filter: drop-shadow(0 2px 3px rgba(15, 23, 42, 0.16));
}

.auth-icon-picker__item i[class$="plus"]::before {
  width: 34px;
  height: 34px;
  font-size: 26px;
}

.auth-icon-picker__item i[class$="plus"]::after {
  display: none !important;
  content: none !important;
}

.auth-icon-picker__item span {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.auth-icon-picker__item:hover,
.auth-icon-picker__item.is-active {
  color: #1d4ed8;
  background: rgba(239, 246, 255, 0.74);
  box-shadow: none;
  transform: translateY(-1px);
}

.auth-icon-picker__item.is-active {
  outline: 1px dashed rgba(37, 99, 235, 0.42);
  outline-offset: -3px;
}

.auth-drawer ::v-deep .el-input-group__prepend {
  min-width: 54px;
  padding: 0 10px;
  text-align: center;
  background: #f8fafc;
}

.auth-drawer ::v-deep .el-input-group__prepend i[class$="plus"] {
  width: 24px;
  height: 24px;
  margin-right: 0;
}

.empty-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px;
  font-size: 14px;
  color: #909399;
}

.drawer-form-body {
  padding: 20px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
